module.exports = __webpack_public_path__ + "static/media/mobileberkshire.1bc4a9d8.svg";